import { z } from 'zod'

/**
 * /dashboard 的 search params 契约(路由与图表卡共用,避免两处各写一份取值面)。
 *
 * 趋势区间是「有意义的应用状态」,按验收规则必须进 URL:冷加载 /dashboard?days=90
 * 要直接还原 90 天视图。非法值走 catch 降级到 30,不让脏 URL 把页面打崩。
 */
export const DEFAULT_DASHBOARD_DAYS = 30

export const dashboardSearchSchema = z.object({
  days: z
    .union([z.literal(7), z.literal(30), z.literal(90)])
    .catch(DEFAULT_DASHBOARD_DAYS)
    .default(DEFAULT_DASHBOARD_DAYS),
})

export type DashboardDays = z.infer<typeof dashboardSearchSchema>['days']

/** 等于默认值的参数不回写 URL(stripSearchParams,A4 全站统一):裸 /dashboard 就是 30 天档。 */
export const DASHBOARD_SEARCH_DEFAULTS = {
  days: DEFAULT_DASHBOARD_DAYS,
} satisfies Partial<z.infer<typeof dashboardSearchSchema>>

/** 切换器可选项;类型标注保证它永远是 schema 取值面的子集(多写一个 60 就编译不过)。 */
export const DASHBOARD_DAYS_OPTIONS: readonly DashboardDays[] = [7, 30, 90]
